<template>
  <div class="ua-flag-event-detail">
    <template v-if="isRugby && game.homeTeam">
      <div class="top-bar">
        <div class="top-title overflow-text">{{ match.chineseName }}</div>
        <div class="top-more" @click="goSchedule">更多</div>
      </div>
      <div class="sheet">
        <div class="scoreboard">
          <div class="round-badge">{{ bmGame.roundDescription || '—' }}</div>
          <div class="scoreboard-row">
            <div class="sb-team">
              <img class="sb-badge" :src="filterImage(game.homeTeam.badge, 40, 40, 2)" alt="" />
              <span class="sb-name overflow-text">{{ game.homeTeam.name }}</span>
            </div>
            <div class="sb-center">
              <div class="sb-score">
                <span v-if="bmGame.homeScore >= 0">{{ getRegularScore(bmGame, 'home') }}</span>
                <span class="sb-dash">{{ (bmGame.homeScore >= 0 && bmGame.awayScore >= 0) ? '—' : 'VS' }}</span>
                <span v-if="bmGame.awayScore >= 0">{{ getRegularScore(bmGame, 'away') }}</span>
              </div>
              <div
                class="sb-state"
                @click="goLive"
                :style="{ color: gameStatusMap(bmGame).color }"
              >
                {{ gameStatusMap(bmGame).label }}
              </div>
            </div>
            <div class="sb-team">
              <img class="sb-badge" :src="filterImage(game.awayTeam.badge, 40, 40, 2)" alt="" />
              <span class="sb-name overflow-text">{{ game.awayTeam.name }}</span>
            </div>
          </div>
        </div>
        <div class="section" v-if="statRows.length > 0">
          <div class="section-title">
            <span class="section-title-text">比赛数据</span>
          </div>
          <div class="stats-table-wrap">
            <div class="stats-scroll">
              <table class="stats-table" cellspacing="0" cellpadding="0">
                <thead>
                  <tr>
                    <th class="sticky-col th-team" style="font-size: 16px;">球队</th>
                    <th v-for="col in rugbyCols" :key="col.value" class="th-metric">
                      <div class="th-zh">{{ col.labelZh }}</div>
                      <div class="th-sub">{{ col.labelShort }}</div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in statRows" :key="row.id || row.name">
                    <td class="sticky-col td-team overflow-text">{{ row.name }}</td>
                    <td v-for="col in rugbyCols" :key="col.value" class="td-val">
                      {{ formatStat(row.stats, col.value) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="section">
          <div class="section-title">
            <span class="section-title-text">比赛信息</span>
          </div>
          <div class="info-card">
            <div class="info-row">
              <span class="info-label">时间</span>
              <div class="info-value">
                {{ date[filterDate(bmGame.beginDate, 'd')] }} {{ filterDate(bmGame.beginDate, 'HH:mm') }}-{{
                  filterDate(bmGame.endDate, 'HH:mm')
                }} ({{ filterDate(bmGame.beginDate, 'yyyy/MM/DD') }})
              </div>
            </div>
            <div class="info-row">
              <span class="info-label">类型</span>
              <div class="info-value">
                {{ bmGame.sportType }}<span v-if="bmGame.gameType">（{{ bmGame.gameType }}）</span>
              </div>
            </div>
            <div class="info-row">
              <span class="info-label">地址</span>
              <div class="info-value info-value-multi">
                <div v-if="bmGame.venueName">{{ bmGame.venueName }}</div>
                <div v-if="bmGame.location">{{ bmGame.location }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div v-else-if="loaded && !isRugby" class="wrong-sport">
      <p>该定制页仅支持橄榄球赛况</p>
      <van-button type="primary" size="small" @click="goStandardActivity">查看标准赛况页</van-button>
    </div>
  </div>
</template>

<script>
import { bkGetBMGameBktData, getBMGameDetail, getBMRugbyGameStats } from '@/api/match'
import { QNImageUtil } from '@/utils'
import Moment from 'moment'
import { Toast } from 'vant'
import Vue from 'vue'

Vue.use(Toast)

const RUGBY_COLS = [
  { value: 'passingTD', labelShort: 'PaTD', labelZh: '传球达阵' },
  { value: 'rushingTD', labelShort: 'RuTD', labelZh: '跑球达阵' },
  { value: 'passingYds', labelShort: 'PaYds', labelZh: '传球码数' },
  { value: 'receivingYds', labelShort: 'ReYds', labelZh: '接球码数' },
  { value: 'rushingYds', labelShort: 'RuYds', labelZh: '跑球码数' }
]

export default {
  data() {
    return {
      gameId: '',
      game: {},
      bmGame: {},
      match: {},
      list: [],
      date: ['周末', '周一', '周二', '周三', '周四', '周五', '周六'],
      loaded: false
    }
  },
  computed: {
    isRugby() {
      return this.game && this.game.sportType === '橄榄球'
    },
    rugbyCols() {
      return RUGBY_COLS
    },
    statRows() {
      return this.list.filter(t => t && t.name)
    }
  },
  mounted() {
    this.gameId = this.$route.query.gameId
    if (!this.gameId) {
      Toast('缺少比赛参数 gameId')
      return
    }
    this.bkGetBMGameBktData()
    this.getBMGameDetail()
  },
  methods: {
    bkGetBMGameBktData() {
      bkGetBMGameBktData({ gameId: this.gameId }).then(res => {
        const data = res.data
        this.game = data.game || {}
        this.match = data.match || {}
        this.loaded = true
        if (this.match && this.match.chineseName) {
          document.title = this.match.chineseName
        }
        this.tryWxShare()
        if (this.game.sportType === '橄榄球') {
          this.list = []
          this.getBMRugbyGameStats()
        }
      })
    },
    tryWxShare() {
      if (!this.game.homeTeam || !this.game.awayTeam || !this.bmGame || !this.bmGame.id) return
      const shareObj = {
        title: this.game.homeTeam.name + 'Vs' + this.game.awayTeam.name,
        abstract: (this.match && this.match.chineseName ? this.match.chineseName + '/' : '') + this.bmGame.roundDescription,
        image: QNImageUtil.imageView(this.match && this.match.icon)
      }
      this.wxShare(shareObj)
    },
    getBMGameDetail() {
      getBMGameDetail({ gameId: this.gameId, eventMode: 0, simple: 0 }).then(res => {
        const data = res.data
        const game = data.game
        this.bmGame = game
        if (this.match && this.match.chineseName) {
          document.title = this.match.chineseName
        }
        this.tryWxShare()
      })
    },
    getBMRugbyGameStats() {
      getBMRugbyGameStats({ mode: 1, gameId: this.gameId }).then(res => {
        const data = res.data
        this.list = []
        if (data.homeTeam) this.list.push(data.homeTeam)
        if (data.awayTeam) this.list.push(data.awayTeam)
      })
    },
    getRegularScore(game, team) {
      if (!game) return ''
      const scoreKey = team === 'home' ? 'homeScore' : 'awayScore'
      const penaltyKey = team === 'home' ? 'homePenalty' : 'awayPenalty'
      const plusKey = team === 'home' ? 'homePlus' : 'awayPlus'
      const totalScore = typeof game[scoreKey] === 'number' ? game[scoreKey] : (game[scoreKey] ? Number(game[scoreKey]) : -1)
      const penaltyScore = game[penaltyKey] && game[penaltyKey] !== -1 ? Number(game[penaltyKey]) : 0
      const plusScore = game[plusKey] && game[plusKey] !== -1 ? Number(game[plusKey]) : 0
      if (totalScore < 0 || isNaN(totalScore)) return ''
      const regularScore = totalScore - penaltyScore - plusScore
      return regularScore >= 0 ? regularScore : totalScore
    },
    gameStatusMap(game) {
      const liveStatus = game.liveStatus
      const ret = { label: '', color: '#fff' }
      if (liveStatus) {
        ret.label = liveStatus.statusLabel
        if (liveStatus.status === -3 || liveStatus.status === 0 || (liveStatus.status === -1 && liveStatus.statusLabel === '即将直播')) {
          ret.color = '#CF2F30'
          if (liveStatus.status === -3) ret.label = '即将直播'
        } else if ((liveStatus.status === -1 && liveStatus.statusLabel === '比赛进行中') || liveStatus.status === 1) {
          ret.color = '#CF2F30'
          if (liveStatus.status === 1) ret.label = this.$t('match.schedule.text_2')
        } else if (liveStatus.status === 2) {
          ret.color = '#369AD4'
        }
      } else if (game.stateDesc) {
        if (game.state === 1) {
          ret.color = '#38906B'
          ret.label = '等待开赛'
        } else if (game.state === 0) {
          ret.color = '#38906B'
          ret.label = '正在报名'
        } else if (game.state === 2) {
          ret.label = game.stateDesc
          ret.color = '#CF2F30'
        } else if (game.state === 3) {
          ret.label = game.stateDesc
        }
      } else {
        if (game.gameNotBegin === 1) {
          ret.color = '#38906B'
          ret.label = '即将开赛'
        } else if (game.gameEnd === 0) {
          ret.color = '#CF2F30'
          ret.label = '比赛进行中'
        } else {
          ret.label = this.$t('match.schedule.text_3')
        }
      }
      if (liveStatus && liveStatus.statusLabel === '视频录像') {
        ret.label = this.$t('match.schedule.text_4')
      }
      return ret
    },
    goLive() {
      if (this.bmGame.liveStatus && (this.bmGame.liveStatus.status === 1 || this.bmGame.liveStatus.status === 2)) {
        this.$router.push({ path: `/live-page/${this.gameId}` })
      }
    },
    goSchedule() {
      if (this.match && this.match.id) {
        // ua-flag/match/59702/schedule
        this.$router.push({ path: `/ua-flag/match/${this.match.id}/schedule` })
        // this.$router.push({ path: '/match/MatchSchedule', query: { matchId: this.match.id } })
      }
    },
    goStandardActivity() {
      this.$router.replace({ path: '/event/activity', query: { gameId: this.gameId } })
    },
    filterDate(date, type) {
      return Moment(date).format(type)
    },
    filterImage(img, w, h, mode) {
      return QNImageUtil.imageView(img, parseInt(2 * w, 10), parseInt(2 * h, 10), mode)
    },
    formatStat(stats, key) {
      if (!stats || stats[key] === undefined || stats[key] === null) return '—'
      const v = stats[key]
      if (v === -1) return '—'
      return v
    }
  }
}
</script>

<style scoped lang="scss">
.overflow-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ua-flag-event-detail {
  min-height: 100vh;
  width: 100%;
  background: #c8102e;
  overflow-x: hidden;
}

.top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px 18px;
  color: #fff;
  font-size: 15px;
}

.top-title {
  flex: 1;
  font-weight: 600;
  padding-right: 12px;
}

.top-more {
  flex-shrink: 0;
  font-size: 14px;
  opacity: 0.95;
  cursor: pointer;
}

.sheet {
  background: #000;
  border-radius: 22px 22px 0 0;
  padding: 20px 16px 40px;
  min-height: calc(100vh - 52px);
  box-sizing: border-box;
}

.scoreboard {
  border-radius: 10px;
  background: radial-gradient(70% 197% at 94% 115%, #282831 0%, #D4021A 100%, #DC0019 100%);
  height: 107px;
  color: #fff;
  text-align: center;
  position: relative;
  font-size: 0px;
}

.round-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 62px;
  height: 18px;
  margin: 0 auto 6px;
  box-sizing: border-box;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  color: #fff;
  background: linear-gradient(180deg, #ff7a3d 0%, #ff682c 45%, #e85a24 100%);
  clip-path: polygon(0 0, 100% 0, 80% 100%, 20% 100%);
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 2px;
}

.scoreboard-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.sb-team {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.sb-badge {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 8px;
}

.sb-name {
  font-size: 13px;
  max-width: 100%;
}

.sb-center {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 4px;
}

.sb-score {
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 0.02em;
  display: flex;
  align-items: center;
  gap: 8px;
}

.sb-dash {
  font-weight: 500;
  opacity: 0.85;
}

.sb-state {
  margin-top: 10px;
  font-size: 13px;
  cursor: pointer;
}

.section {
  margin-top: 28px;
}

.section-title {
  margin-bottom: 14px;
}

.section-title-text {
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  position: relative;
  z-index: 2;
}

.stats-table-wrap {
  border-radius: 10px 0px 0px 10px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.06);
  width: calc(100vw - 16px);
}

.stats-scroll {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    height: 4px;
    display: none;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 2px;
  }
}

.stats-table {
  width: max-content;
  min-width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 16px;
  color: #fff;
}

.stats-table th,
.stats-table td {
  padding: 10px 8px;
  text-align: center;
  vertical-align: middle;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  min-width: 56px;
}

.th-team,
.td-team {
  min-width: 72px;
  max-width: 88px;
  text-align: left !important;
  padding-left: 12px !important;
  background: #141418 !important;
  font-weight: 500;
  font-size: 14px;
}

.sticky-col {
  position: sticky;
  left: 0;
  z-index: 2;
  box-shadow: 4px 0 8px rgba(0, 0, 0, 0.25);
}

.stats-table thead .sticky-col {
  z-index: 3;
}

.th-metric {
  background: #1e1e24;
  font-weight: 500;
}

.th-zh {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.88);
  line-height: 1.3;
}

.th-sub {
  font-size: 10px;
  color: #b4b4bf;
  margin-top: 4px;
}

.td-val {
  background: #1a1a1f;
}

.stats-table tbody tr:nth-child(even) .td-val {
  background: #222228;
}

.stats-table tbody tr:nth-child(even) .td-team {
  background: #18181c !important;
}

.info-card {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 8px 16px 4px;
}

.info-row {
  display: flex;
  padding: 14px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  font-size: 14px;
  align-items: flex-start;

  &:last-child {
    border-bottom: none;
  }
}

.info-label {
  flex-shrink: 0;
  width: 48px;
  color: #b4b4bf;
}

.info-value {
  flex: 1;
  color: #fff;
  line-height: 1.5;
  margin-left: 12px;
  word-break: break-all;
}

.info-value-multi div + div {
  margin-top: 4px;
}

.wrong-sport {
  padding: 48px 24px;
  text-align: center;
  color: #fff;
  font-size: 15px;

  p {
    margin-bottom: 20px;
  }
}
</style>
